import React, { Component } from 'react';

import Immutable, {Range} from 'immutable';
import { firebaseRoot, snapshotToArray } from '../../utils/firebase-utils';
import ReactFireMixin from 'reactfire';
import { Router, Route } from 'react-router';

import TouchButton from '../../components/TouchButton';
import TouchLink from '../../components/TouchLink';
import LinkTR from '../../components/LinkTR';
import Glyphicon from 'react-bootstrap/lib/Glyphicon';
import _ from 'lodash';

const Dashboard = React.createClass({
    mixins: [ReactFireMixin],

    componentDidMount() {
        this.bindAsArray(firebaseRoot.child('admin/base/books'), 'books');
        this.bindAsDataSnapshot(firebaseRoot.child('admin/stats/books'), 'stats');
    },

    publishBook(book) {
        if (window.confirm(`Are you sure you want to publish ${book.name}?`)) {
            firebaseRoot.child('admin/queue/tasks').push({type: 'publish_book', bookId: book['.key']})
        }
    },

    render() {
        if (!this.state) {
            return <div>Loading...</div>;
        }
        return (
            <table className="table table-hover">
                <thead>
                <tr>
                    <th>ISBN</th>
                    <th>Name</th>
                    <th>Exercises</th>
                    <th>Started</th>
                    <th>Completed<br/>(not implemented)</th>
                    <th>Approved<br/>(not implemented)</th>
                    <th>&nbsp;</th>
                </tr>
                </thead>
                <tbody>
                {this.state.books.map(book => {
                    const stats = this.state.stats.child(book['.key']).val() || {};
                    return <LinkTR key={book['.key']} to={`/admin/book/${book['.key']}`}>
                        <td>{book['.key']}</td>
                        <td>{book.title}</td>
                        <td>{stats.total}</td>
                        <td>{stats.started}</td>
                        <td>{stats.completed}</td>
                        <td>{stats.approved}</td>
                        <td>
                            {stats.started &&
                            <TouchButton onClick={this.publishBook.bind(this, book)}>
                                <Glyphicon glyph="circle-arrow-top" />&nbsp;Publish
                            </TouchButton>}
                        </td>
                    </LinkTR>;
                })}
                </tbody>
            </table>
        );
    }
});

export default Dashboard;



/** WEBPACK FOOTER **
 ** ./src/admin/screens/Dashboard.js
 **/